<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div>
            <FormInput :label="$t('formularios.dni')" name="dni" rules="required" data-cy="dni" v-model="abonado.dni" />
            <FormInput class="mb-3 mb-lg-4" v-if="!manager.renovar_abono_solo_con_dni" :label="$t('formularios.n_abonado_anterior', {abonado: teatro.texto_abonado.toUpperCase()})" name="n_abonado_antiguo" rules="required" v-model="abonado.n_abonado_antiguo" />
        </div>
        
        <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_abono.renovar') }}</span></button>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['abonado'],
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
    }
</script>